import { Link } from "@mui/material";
import { CreateOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "store";
import { useStyles } from "./edit-link-style";
import { goToStep } from "store/bookingJourney";
import { BookingJourneyStep } from "utils/types";

export interface EditLinkProps {
  goto: BookingJourneyStep;
  ariaLabel: string;
}

export const EditLink = ({ goto, ariaLabel }: EditLinkProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const classes = useStyles();

  return (
    <>
      <CreateOutlined className={classes.icon} />
      <Link
        tabIndex={0}
        className={classes.editText}
        aria-label={ariaLabel}
        onClick={() => dispatch(goToStep(goto))}
        role="link"
      >
        {t("edit")}
      </Link>
    </>
  );
};
